module.exports = __webpack_public_path__ + "static/media/M61ws.1314ce0c.pdf";